module.exports = __webpack_public_path__ + "fastpay.svg?4095deb2b34d6d92602f637babd15f51";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fastpay.svg
// module id = 324
// module chunks = 0